<form [formGroup]="form" class="w-full">
  <div class="flex flex-col gap-2">
    <div class="">
      <input pInputText id="name" formControlName="name" class="w-full" [placeholder]="collectionType.collection.formTitles[0]" />
    </div>
    <div>
      <!-- <label for="site" class="mb-1 block text-sm font-medium text-gray-700">Site</label> -->
      <div class="flex gap-2">
        <p-dropdown
          [options]="(sites$ | async) || []"
          formControlName="site"
          placeholder="Select a site"
          [editable]="true"
          [showClear]="true"
          class="flex-1"
          styleClass="w-full"
          placeholder="Site"
        ></p-dropdown>
        <button
          type="button"
          pButton
          icon="pi pi-plus"
          (click)="openAddSiteModal()"
          class="p-button-success"
          pTooltip="Add new site"
          aria-label="Add new site"
        ></button>
      </div>
    </div>
    <div>
      <input pInputText id="primaryContact" formControlName="primaryContact" class="w-full" [placeholder]="collectionType.collection.formTitles[1]" />
    </div>
    <div class="flex flex-row gap-2">
      <div class="flex-1">
        <input pInputText id="telephone" formControlName="telephone" class="w-full" [placeholder]="collectionType.collection.formTitles[4]" />
      </div>
      <div class="flex-1">
        <input pInputText id="email" formControlName="email" class="w-full" [placeholder]="collectionType.collection.formTitles[5]" />
      </div>
    </div>
    <div class="flex">
      <textarea pTextarea placeholder="Address - Ex. 100 Bond St" rows="4" formControlName="address" class="w-full" id="address"></textarea>
    </div>
    <div>
      <input pInputText id="postcode" formControlName="postcode" class="w-full" placeholder="Postcode" />
    </div>
    <div *ngIf="profile.profileType !== 'Manufacturer'">
      <h3>Floors</h3>
      <div [formGroup]="floorForm" class="flex flex-col gap-2">
        <ng-container *ngIf="(floorForm.controls.data | returnFormArray).controls.length === 0">
          <p>No floors set up yet!</p>
        </ng-container>
        <ng-container formArrayName="data">
          <ng-container *ngFor="let section of (floorForm.controls.data | returnFormArray).controls; let i = index">
            <div class="flex flex-row">
              <input pInputText id="floor" [formControlName]="i" class="flex-1" placeholder="Floor reference" />
              <div (click)="delete(i)" class="self-center pl-2 text-slate-500 cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                  <path
                    fill-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm3 10.5a.75.75 0 000-1.5H9a.75.75 0 000 1.5h6z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="w-full flex flex-row justify-between gap-2 mt-4">
    <button (click)="add()" type="button" class="px-4 py-3 text-base text-white bg-slate-500 rounded-full" *ngIf="profile.profileType !== 'Manufacturer'">
      Add floor
    </button>
    <div class="flex gap-2">
      <button *ngIf="hasRole('importExport')" (click)="import()" type="button" class="bg-white px-4 py-3 text-sm text-blue rounded-full transition">
        Import
      </button>
      <p-button label="Create" icon="pi pi-check" [loading]="btnProcessing" [rounded]="true" severity="info" (onClick)="create()" />
    </div>
  </div>
</form>
